<template>
    <footer class="main-footer text-center" style="bottom: 50px">
        <p class="font-xs">
            {{year}} © Bashundhara Ready Roti - Developed by <a href="www.sslwireless.com">SSL Wireless</a>
        </p>
        <p class="font-xs mb-30">All rights reserved</p>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear()
        }
    }
}
</script>